class AnimationScroll extends HTMLElement {
        constructor() {
            super();
            this.options = {
                root: null,
                threshold: 0.4,
            }
            this.isAnimation = true;
            this.observer =  new IntersectionObserver(this.watchElement.bind(this), this.options);
            this.observer.observe(this)
        }

        watchElement(entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting && this.isAnimation ) {
                   this.classList.add('animation-start'); 
                   this.isAnimation = false
                }
            });
        }
    }

customElements.define('animation-scroll', AnimationScroll)